import { css } from "@emotion/core"

const StyledButton = css`
  padding: 1rem 3rem;
  display: inline-block;
  margin-top: 2rem;
  font-weight: 700;
  font-size: 2.6rem;
  text-transform: uppercase;
  text-align: center;
  text-decoration: none;
  transition: all 0.2s ease;
  background: unset;
  cursor: pointer;

  &.light {
    border: 5px solid #f15d2e;
    color: #f15d2e;

    &:hover {
      background: #f15d2e;
      color: white;
    }
  }

  &.dark {
    border: 5px solid #fff;
    color: #fff;

    &:hover {
      background: #fff;
      color: #f15d2e;
    }
  }
`

export default StyledButton
